import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Icon,
  Box,
} from "@chakra-ui/react";
import { MdArticle } from "react-icons/md";
import { useSetRecoilState } from "recoil";
import React, { useEffect, useState } from "react";
import useAxios from "axios-hooks";

import Logs from "../components/Logs";
import Card from "components/card/Card";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import logger from "infra/logger";
import { toastState } from "atoms/toastState";

const OcppLogs = ({ id }) => {
  const [chargePoints, setChargePoints] = useState([]);
  
  const setToast = useSetRecoilState(toastState);

  const [{ data, loading, error }, getChargePoint] = useAxios(
    { method: "GET", url: `/api/stations/forLocation/${id}` },
    { manual: true }
  );

  const getChargePoints = async () => {
    try {
      const response = await getChargePoint();
      setChargePoints(response.data.data);
      setToast({
        status: "success",
        message: "Charge Points fetched successfully",
        title: "Success",
        position: "top-right",
        duration: 5000,
      })
    } catch (error) {
      logger.log(error);
      setToast({
        title: "Error fetching charge points",
        status: "error",
        duration: 5000,
        iseOpen: true,
      });
    }
  };

  const ocppLogTabs = chargePoints.map((ele, index) => {
    return (
      <Tab
        key={index}
        _focus={{ boxShadow: "none" }}
        borderRadius="lg"
        px={3}
        py={2}
        fontWeight="500"
        color="gray.600"
        position="relative"
        zIndex="1"
        _selected={{
          bg: "rgba(245, 125, 54, 0.15)",
          color: "#f57d36",
          fontWeight: "600",
          boxShadow: "0 2px 4px rgba(245, 125, 54, 0.1)",
        }}
        _hover={{
          bg: "rgba(245, 125, 54, 0.08)",
          color: "#f57d36",
        }}
      >
        <Flex align="center" gap={1.5}>
          <Icon as={MdArticle} boxSize={4} />
          <Text>{ele.StationId}</Text>
        </Flex>
      </Tab>
    );
  });

  const ocppLogPanels = chargePoints.map((ele, index) => {
    return (
      <TabPanel key={index}>
        <Logs point={ele} />
      </TabPanel>
    );
  });

  useEffect(() => {
    getChargePoints();
  }, []);

  return !loading ? (
    <Card minH="60vh" height="100%">
      {chargePoints.length > 0 && (
        <Tabs isLazy variant="unstyled">
          <Flex
            flexDirection="row"
            alignItems="start"
            justifyContent="space-between"
          >
            <Box
              bg="rgba(255, 255, 255, 0.6)"
              backdropFilter="blur(12px)"
              borderRadius="xl"
              border="1px solid rgba(245, 125, 54, 0.15)"
              px={1}
              py={2}
              position="relative"
              overflow="hidden"
              _before={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "100%",
                zIndex: 0,
                pointerEvents: "none",
              }}
            >
              <TabList gap={2}>{ocppLogTabs}</TabList>
            </Box>
          </Flex>
          <TabPanels>{ocppLogPanels}</TabPanels>
        </Tabs>
      )}
    </Card>
  ) : (
    <LoadingSpinner />
  );
};

export default OcppLogs;
